/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrysignup1Inputs */

const en_entrysignup1 = /** @type {(inputs: Entrysignup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up on Pulsify`)
};

const de_entrysignup1 = /** @type {(inputs: Entrysignup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung über Pulsify`)
};

/**
* | output |
* | --- |
* | "Sign-up on Pulsify" |
*
* @param {Entrysignup1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrysignup1 = /** @type {((inputs?: Entrysignup1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrysignup1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrysignup1(inputs)
	return de_entrysignup1(inputs)
});
export { entrysignup1 as "entrySignup" }